import ledgeraccService from '../../services/ledgeraccs'

const state = {
    loading: false,
    errors: null,
    ledgeraccs:[] ,
}

const actions = {
    getAll({ commit }) {
        commit('LEDGERACC_LOADING', true)
        ledgeraccService.getAll().then(
            response => {

                commit('LOAD_LEDGERACCS', response.data)
                commit('LEDGERACC_LOADING', false)
                commit('LEDGERACC_FAILURE', null)
            },
            error => {
                commit('LEDGERACC_FAILURE', error)
                commit('LEDGERACC_LOADING', false)
            }
        )
    },
    add({ commit }, data) {
        commit('LEDGERACC_LOADING', true)
        commit('LEDGERACC_FAILURE', null)

        ledgeraccService.add(data).then(
            response => {
                data.id = response.data.id
                commit('ADD_LEDGERACC', data)
                commit('LEDGERACC_LOADING', false)

            },
            error => {
                commit('LEDGERACC_FAILURE', error)
                commit('LEDGERACC_LOADING', false)
            }
        )
    },
    update({ commit }, data) {
        commit('LEDGERACC_LOADING', true)
        commit('LEDGERACC_FAILURE', null)
        data.ledgeracc.roles = "ledgeracc"
        ledgeraccService.update(data.ledgeracc)
            .then(
                response => {
                    commit('UPDATE_LEDGERACC', data)
                    commit('LEDGERACC_LOADING', false)

                },
                error => {
                    commit('LEDGERACC_FAILURE', error)
                    commit('LEDGERACC_LOADING', false)
                }
            )


    },
    delete({ commit }, data) {
        commit('LEDGERACC_LOADING', true)
        commit('LEDGERACC_FAILURE', null)
        ledgeraccService.delete(data.ledgeracc.id)
            .then(
                response => {

                    commit('DELETE_LEDGERACC', data)
                    commit('LEDGERACC_LOADING', false)

                },
                error => {
                    commit('LEDGERACC_FAILURE', error)
                    commit('LEDGERACC_LOADING', false)
                }
            )
    }
}

const mutations = {
    ADD_LEDGERACC(state, payload) {
        state.ledgeraccs.unshift(payload);
    },
    LOAD_LEDGERACCS(state, payload) {
        state.ledgeraccs = payload
    },
    UPDATE_LEDGERACC(state, payload) {
        Object.assign(state.ledgeraccs[payload.index], payload.ledgeracc);
    },
    DELETE_LEDGERACC(state, payload) {
        state.ledgeraccs.splice(payload.index, 1)
    },
    LEDGERACC_FAILURE(state, payload) {
        state.errors = payload
    },

    LEDGERACC_LOADING(state, payload) {
        state.loading = payload
    },
}


const getters = {
    LEDGERACCS: state => {
        return state.ledgeraccs
    },

    LEDGERACC_ERROR: state => {
        return state.errors
    },

    LEDGERACC_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
